var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowNext(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "24px",
    viewBox: "0 0 14 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrowNext") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1138.70451,493.905031 L1147.61949,485.001122 C1147.86496,484.756543 1148,484.429535 1148,484.080855 C1148,483.731982 1147.86496,483.405167 1147.61949,483.160202 L1146.83831,482.380413 C1146.59322,482.13506 1146.2656,482 1145.91647,482 C1145.56734,482 1145.24011,482.13506 1144.99483,482.380413 L1134.38013,492.981281 C1134.13388,493.227021 1133.99904,493.555384 1134.00001,493.90445 C1133.99904,494.255065 1134.13369,494.583041 1134.38013,494.828974 L1144.98494,505.419587 C1145.23023,505.66494 1145.55746,505.8 1145.90678,505.8 C1146.25591,505.8 1146.58314,505.66494 1146.82862,505.419587 L1147.6096,504.639798 C1148.1178,504.132259 1148.1178,503.306031 1147.6096,502.798685 L1138.70451,493.905031 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup---add-private-album---view-shared-images",
    transform: "translate(-1134.000000, -482.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icArrowNext",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(1141.000000, 493.900000) rotate(180.000000) translate(-1141.000000, -493.900000) ",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowNext);
export default __webpack_public_path__ + "static/media/icArrowNext.defffc8b3591911b297e899c62eba1d7.svg";
export { ForwardRef as ReactComponent };